import { defineMessage } from 'services/localization';

export const messages = {
    nsTransactionNumberFieldText: defineMessage('transaction_number'),
    nsCheckNumberFieldText: defineMessage('check_number'),
    nsTransactionDateFieldText: defineMessage('date'),
    nsPostingPeriodFieldText: defineMessage('posting_period'),
    nsMemoFieldText: defineMessage('memo'),
    nsPayablesAccountFieldText: defineMessage('ap_account'),
    nsAccountFieldText: defineMessage('account'),
    nsDepartmentFieldText: defineMessage('department'),
    nsClassFieldText: defineMessage('class'),
    nsLocationFieldText: defineMessage('location'),
    nsToBePrintedFieldText: defineMessage('to_be_printed'),
    nsPrintVoucherFieldText: defineMessage('print_voucher'),
    toBePrintedPositiveValue: defineMessage('yes'),
    printVoucherPositiveValue: defineMessage('yes'),
};
